import React from 'react';
import { AppBar, Box, Button, Toolbar, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { clearAllCookies } from '../cookieUtils';

const TenantManagementHeader = ({
  title = 'Superadmin Tenant Management',
  signOutRedirectPath = '/',
  onSignOut,
  onAfterSignOut,
}) => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    if (typeof onSignOut === 'function') {
      await onSignOut();
      return;
    }
    try {
      await signOut(auth);
    } catch (e) {
      // Ignore signOut errors and force local sign-out anyway.
    }
    clearAllCookies();
    if (typeof onAfterSignOut === 'function') {
      onAfterSignOut();
    } else {
      navigate(signOutRedirectPath);
    }
  };

  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={0}
      sx={{ borderBottom: '1px solid #e6eaf0', backgroundColor: '#ffffff' }}
    >
      <Toolbar sx={{ minHeight: '64px !important', position: 'relative', px: { xs: 2, sm: 3 } }}>
        <Box sx={{ width: { xs: 96, sm: 132 } }} />
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            color: '#1f2a37',
          }}
        >
          {title}
        </Typography>
        <Box sx={{ ml: 'auto' }}>
          <Button
            onClick={handleSignOut}
            startIcon={<LogoutIcon />}
            sx={{ textTransform: 'none', fontWeight: 600, borderRadius: 2, px: 1.5 }}
          >
            Sign Out
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TenantManagementHeader;
